import { Card, styled } from '@mui/material';

export const StyledCard = styled(Card)<{
  isDragging: boolean;
  error: boolean;
  loading: boolean;
  disabled?: boolean;
}>(({ theme, error, disabled = false, loading, isDragging }) => ({
  opacity: isDragging ? 0 : 1,

  borderRadius: '6px',
  borderColor: error ? theme.palette.error.main : undefined,
  svg: { color: error ? theme.palette.error.main : undefined },
  transition: 'all 0.2s',

  '&:hover': {
    borderColor: error || loading || disabled ? undefined : theme.palette.primary.main,
    svg: { color: error || loading || disabled ? undefined : theme.palette.primary.main },
  },

  '@keyframes loading-animation': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.25 },
    '100%': { opacity: 1 },
  },

  animation: loading ? 'loading-animation 1.5s ease-in-out infinite' : undefined,
}));
